<ion-app>
  <!-- Global Language Switcher - Header Style -->
  <!-- <app-global-language-switcher></app-global-language-switcher> -->
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<app-select-store></app-select-store>